module.exports = __webpack_public_path__ + "static/media/Gilderoy Lockhart 1.d73efa57.jpg";